"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var OnClickOutside = /*#__PURE__*/function (_React$PureComponent) {
  function OnClickOutside(props) {
    var _this;
    (0, _classCallCheck2["default"])(this, OnClickOutside);
    _this = _callSuper(this, OnClickOutside, [props]);
    _this.wrapperRef = /*#__PURE__*/_react["default"].createRef();
    _this.onClickOutside = _this.onClickOutside.bind(_this);
    return _this;
  }
  (0, _inherits2["default"])(OnClickOutside, _React$PureComponent);
  return (0, _createClass2["default"])(OnClickOutside, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      window.addEventListener('mousedown', this.onClickOutside, true);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('mousedown', this.onClickOutside, true);
    }
  }, {
    key: "onClickOutside",
    value: function onClickOutside(e) {
      var current = this.wrapperRef.current;
      var onClickOutside = this.props.onClickOutside;
      if (current && !current.contains(e.target)) {
        onClickOutside(e);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        children = _this$props.children,
        className = _this$props.className;
      return /*#__PURE__*/_react["default"].createElement("div", {
        ref: this.wrapperRef,
        className: className
      }, children);
    }
  }]);
}(_react["default"].PureComponent);
OnClickOutside.defaultProps = {
  className: ''
};
OnClickOutside.propTypes = {
  className: _propTypes["default"].string,
  children: _propTypes["default"].node.isRequired,
  onClickOutside: _propTypes["default"].func.isRequired
};
var _default = exports["default"] = OnClickOutside;